import {createContext} from 'react'

export const contextApp = createContext(null);